module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/jumpstart-plan-widget-4c50a0aa4e09b6e120fd383978df9d92.jpg";